module.exports = __webpack_public_path__ + "static/media/ben-parker-OhKElOkQ3RE-unsplash.bd28ade3.jpg";